var _ellipse, _path, _ellipse2, _path2, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSeoOrangeHero(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 53,
    height: 54,
    viewBox: "0 0 53 54",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 26.4559,
    cy: 27.1154,
    rx: 26.0008,
    ry: 26.1618,
    fill: "#F84A23"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M37.0937 35.2694C37.5364 34.8239 38.2542 34.8239 38.6969 35.2694L42.4755 39.0714C42.9182 39.5168 42.9182 40.239 42.4755 40.6844C42.0328 41.1299 41.315 41.1299 40.8723 40.6844L37.0937 36.8824C36.651 36.437 36.651 35.7148 37.0937 35.2694Z",
    fill: "white"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 32.6053,
    cy: 30.7532,
    rx: 9.06866,
    ry: 9.12481,
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.311 30.7532C10.311 30.1232 10.8186 29.6125 11.4446 29.6125H19.0018C19.6279 29.6125 20.1354 30.1232 20.1354 30.7532C20.1354 31.3831 19.6279 31.8938 19.0018 31.8938H11.4446C10.8186 31.8938 10.311 31.3831 10.311 30.7532Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.311 23.1491C10.311 22.5192 10.8186 22.0085 11.4446 22.0085H19.0018C19.6279 22.0085 20.1354 22.5192 20.1354 23.1491C20.1354 23.7791 19.6279 24.2897 19.0018 24.2897H11.4446C10.8186 24.2897 10.311 23.7791 10.311 23.1491Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.311 15.5451C10.311 14.9152 10.8186 14.4045 11.4446 14.4045H31.0934C31.7194 14.4045 32.227 14.9152 32.227 15.5451C32.227 16.1751 31.7194 16.6857 31.0934 16.6857H11.4446C10.8186 16.6857 10.311 16.1751 10.311 15.5451Z",
    fill: "white"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSeoOrangeHero);
export default __webpack_public_path__ + "static/media/seo-orange-hero.6a6976465566797e981aff7b1152de05.svg";
export { ForwardRef as ReactComponent };